// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"pc_a bie_qt bie_a bie_w","FaqAskQuestion__outdated":"pc_b bie_vr bie_xg"};